import { WeiPerEther } from 'nftx.js';
import { formatEther } from 'viem';

const calculatePriceImpact = (a: bigint, b: bigint): number => {
  if (!a || !b) {
    return 0;
  }
  if (b > a) {
    [a, b] = [b, a];
  }
  return Number(formatEther(((a - b) * WeiPerEther) / a));
};

export default calculatePriceImpact;
